module.exports = __webpack_public_path__ + "static/media/car5.aae05af2.jpg";